export default __webpack_public_path__ + "static/InHub_FS2S_2023-1-a91a79387690f0a1b4e22286cbd4cf4b.jpg";